function initMap() {
    const position = { lat: 49.110600, lng: 21.511950 }

    const map = new google.maps.Map(document.getElementById("map"),  {
        zoom: 17,
        center: position,
        mapId: "map"
    })

    const marker = new google.maps.Marker({
        position: position,
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        title: "Slovenská myelómová spoločnosť o.z."
    })

}

$(document).ready( function() {
    setTimeout(() => {
        if ( $("#map").length ) {
            initMap()
        }
    }, 300)
})
